import { SolViewId } from '@sol/components';
import { AsmLinkedIntegrationViewOptions } from '../components/view/asm-view-read-linked-integration/asm-linked-integration-view-options';

export class AsmIntegrationsViewId {
  public static readonly linkedIntegration = SolViewId.of<AsmLinkedIntegrationViewOptions>('asm.linkedIntegration', {
    canRemove: true,
  });
}
